// Display AppsFlyer banners
// We don't need to typecheck or lint this file as this code is provided by AppsFlyer themselves.

/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable filenames/match-exported */
/* eslint-disable no-sequences */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-param-reassign */
// @ts-nocheck
const appsFlyer = () => {
  !(function (t, e, n, s, a, c, i, o, p) {
    (t.AppsFlyerSdkObject = a),
      (t.AF =
        t.AF ||
        function () {
          (t.AF.q = t.AF.q || []).push(
            [Date.now()].concat(Array.prototype.slice.call(arguments))
          );
        }),
      (t.AF.id = t.AF.id || i),
      (t.AF.plugins = {}),
      (o = e.createElement(n)),
      (p = e.getElementsByTagName(n)[0]),
      (o.async = 1),
      (o.src =
        'https://websdk.appsflyer.com?' +
        (c.length > 0 ? 'st=' + c.split(',').sort().join(',') + '&' : '') +
        (i.length > 0 ? 'af_id=' + i : '')),
      p.parentNode.insertBefore(o, p);
  })(window, document, 'script', 0, 'AF', 'pba,banners', {
    pba: { webAppId: 'fceb3877-f4b3-4bcd-ab1b-adce7a7e3eba' },
    banners: { key: '3cc7a021-979b-4973-9d8e-6a087beb2877' },
  });

  // Smart Banners are by default set to the max z-index value, so they won't be hidden by the website elements. This can be changed if you want some website components to be on top of the banner.

  AF('banners', 'showBanner', {
    bannerZIndex: 1000,
    additionalParams: { p1: 'v1', p2: 'v2' },
  });
};

export default appsFlyer;
/* eslint-enable @typescript-eslint/ban-ts-comment */
/* eslint-enable filenames/match-exported */
/* eslint-enable no-sequences */
/* eslint-enable prefer-rest-params */
/* eslint-enable no-param-reassign */
